import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import CommunicationsListItem from '../CommunicationsListItem';
import CommunicationsGeneralReadReceiptsTab from './tabs/CommunicationsGeneralReadReceiptsTab';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => (
			<DetailsSectionWrapper disablePadding>
				<ViewList {...props} itemLayout={CommunicationsListItem} />
			</DetailsSectionWrapper>
		)
	},
	{
		id: 'read-notifications',
		title: 'TAB_READ_RECEIPTS',
		content: ({ refresh, updateRefresh }) => (
			<CommunicationsGeneralReadReceiptsTab refresh={refresh} updateRefresh={updateRefresh} />
		)
	}
];

export default tabs;
